export const type = 'form.errors';
